import {
  POPULATE_RECEIPT,
  POPULATE_GROUP_RECEIPT,
  POPULATE_RESERVATIONS,
  POPULATE_GROUP_RESERVATIONS,
  POPULATE_RIDERS,
  POPULATE_RIDER_COUNT,
  POPULATE_WALLET,
  POPULATE_WALLET_TRANSACTIONS,
  SET_ACTIVE_RESERVATION,
  SET_ACTIVE_GROUP_RESERVATION,
  SET_ACTIVE_RIDER,
  SET_ACCOUNT_STATUS,
  POPULATE_RESERVATION_CREDITS,
  POPULATE_CUSTOMER_COUPONS,
  POPULATE_RESERVATION_FLEET,
  POPULATE_ACTIVE_PASS,
  POPULATE_FLEETS,
  POPULATE_PASS_OFFERS,
  POPULATE_ACTIVE_TRIP,
  POPULATE_PASS_TRANSACTIONS,
  POPULATE_USER_DEVICES,
  SET_BAN_AND_SUSPENSION_REASON,
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case POPULATE_RIDERS:
      return {
        ...state,
        riders: action.payload,
      };
    case POPULATE_RIDER_COUNT:
      return {
        ...state,
        riderCount: action.payload,
      };
    case POPULATE_RESERVATIONS:
      return {
        ...state,
        reservations: action.payload,
      };
    case POPULATE_WALLET:
      return {
        ...state,
        wallet: action.payload,
      };
    case POPULATE_WALLET_TRANSACTIONS:
      return {
        ...state,
        walletTransactions: action.payload,
      };
    case POPULATE_RECEIPT:
      return {
        ...state,
        receipt: action.payload,
      };
    case POPULATE_GROUP_RECEIPT:
      return {
        ...state,
        groupReceipt: action.payload,
      };
    case SET_ACTIVE_RIDER:
      return {
        ...state,
        activeRider: action.payload,
      };
    case SET_ACCOUNT_STATUS:
      return {
        ...state,
        accountStatus: action.payload,
      };
    case SET_BAN_AND_SUSPENSION_REASON:
      return {
        ...state,
        reasonForBanOrSuspension: action.payload,
      };
    case SET_ACTIVE_RESERVATION:
      return {
        ...state,
        activeReservation: action.payload,
      };
    case SET_ACTIVE_GROUP_RESERVATION:
      return {
        ...state,
        activeGroupReservation: action.payload,
      };
    case POPULATE_RESERVATION_CREDITS:
      return {
        ...state,
        reservationCredits: action.payload,
      };
    case POPULATE_CUSTOMER_COUPONS:
      return {
        ...state,
        customerCoupons: action.payload,
      };
    case POPULATE_RESERVATION_FLEET:
      return {
        ...state,
        reservationFleet: action.payload,
      };
    case POPULATE_ACTIVE_PASS:
      return {
        ...state,
        activePass: action.payload,
      };
    case POPULATE_FLEETS:
      return {
        ...state,
        fleets: action.payload,
      };
    case POPULATE_PASS_OFFERS:
      return {
        ...state,
        passOffers: action.payload,
      };
    case POPULATE_ACTIVE_TRIP:
      return {
        ...state,
        activeTrip: action.payload,
      };
    case POPULATE_PASS_TRANSACTIONS:
      return {
        ...state,
        passTransactions: action.payload,
      };
    case POPULATE_USER_DEVICES:
      return {
        ...state,
        userDevices: action.payload,
      };
    case POPULATE_GROUP_RESERVATIONS:
      return {
        ...state,
        groupReservations: action.payload,
      };
    default:
      return state;
  }
};
